<template>
  <div class="loading-box" v-if="visible">
    <div class="loading-bg"></div>
    <span class="loading iconfont icon-pop_icon_wlyc-copy"></span>
  </div>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.loading-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  .loading-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.6);
    filter: blur(2px);
    z-index: -1;
  }
  .loading {
    display: inline-flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #25e6ab;
    animation: circle-round 5s linear infinite;
  }
}

@keyframes circle-round {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>